"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryService = void 0;
const enums_1 = require("../enums");
const cookies_next_1 = require("cookies-next");
exports.QueryService = {
    getLocale: (context) => {
        var _a, _b, _c, _d, _e;
        let locale = 'ru';
        if (context === null || context === void 0 ? void 0 : context.locale) {
            locale = context === null || context === void 0 ? void 0 : context.locale;
            if (locale !== ((_b = (_a = context === null || context === void 0 ? void 0 : context.req) === null || _a === void 0 ? void 0 : _a.cookies) === null || _b === void 0 ? void 0 : _b.lang)) {
                (0, cookies_next_1.setCookie)('lang', locale);
            }
        }
        else if ((_c = context === null || context === void 0 ? void 0 : context.req) === null || _c === void 0 ? void 0 : _c.cookies) {
            locale = (_e = (_d = context === null || context === void 0 ? void 0 : context.req) === null || _d === void 0 ? void 0 : _d.cookies) === null || _e === void 0 ? void 0 : _e.lang;
            if (locale !== (0, cookies_next_1.getCookie)('lang')) {
                (0, cookies_next_1.setCookie)('lang', locale);
            }
        }
        else if ((0, cookies_next_1.hasCookie)('lang')) {
            locale = (0, cookies_next_1.getCookie)('lang');
        }
        else {
            (0, cookies_next_1.setCookie)('lang', locale);
        }
        return locale;
    },
    requestWithAnswer: async function (link = ``, options = { method: 'GET' }, type = enums_1.EResponseType.Json) {
        const response = await this.request(link, options, type);
        console.log('/' + link.split('/').slice(3).join('/'), response, type);
        return response;
    },
    request: async function (link = ``, options = { method: 'GET' }, type = enums_1.EResponseType.Json) {
        var _a;
        if (process.env.NEXT_PUBLIC_DEBUG === 'true')
            console.log(link
                ? `request link ${(_a = options === null || options === void 0 ? void 0 : options.method) !== null && _a !== void 0 ? _a : 'GET'}: ${link}`
                : `empty link: ${typeof link}`);
        try {
            const response = await fetch(link, options);
            if (!response.ok) {
                if (typeof window !== 'undefined')
                    console.error(`Ошибка: ${link}`);
                throw new Error(`Ошибка: ${response.status} ${response.statusText}`);
            }
            switch (type) {
                case enums_1.EResponseType.Json:
                    return await response.json();
                case enums_1.EResponseType.Text:
                    return await response.text();
                case enums_1.EResponseType.Blob:
                    return await response.blob();
                default:
                    return null;
            }
        }
        catch (error) {
            console.error(`Произошла ошибка: ${error} по запросу ${link}`);
            if (typeof window !== 'undefined')
                console.error(`${error}`);
            switch (type) {
                case enums_1.EResponseType.Json:
                    return null;
                case enums_1.EResponseType.Text:
                    return '';
                case enums_1.EResponseType.Blob:
                    return null;
                default:
                    return null;
            }
        }
    },
    requests: async function (...args) {
        var _a;
        const requests = [];
        let current = { link: '' };
        for (const arg of args) {
            if (typeof arg === 'string') { // link
                if (current.link)
                    requests.push(current);
                current = { link: arg };
            }
            else if (typeof arg === 'object' && !Array.isArray(arg)) { // options
                current.options = arg;
            }
            else if (Object.values(enums_1.EResponseType).includes(arg)) { // type
                current.type = arg;
            }
        }
        if (current.link)
            requests.push(current);
        const answer = {};
        for (let i = 0; i < requests.length; i++) {
            try {
                answer[`dto${i + 1}`] = (_a = await this.request(...Object.values(requests[i]))) !== null && _a !== void 0 ? _a : null;
            }
            catch (e) {
                answer[`dto${i + 1}`] = null;
            }
        }
        return answer;
    },
    transaction: async function (url, items) {
        try {
            const results = await Promise.all(items.map(async (item) => {
                try {
                    const res = await exports.QueryService.request(url, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${(0, cookies_next_1.getCookie)('accessToken')}`
                        },
                        body: JSON.stringify(item),
                    });
                    const data = res;
                    return (data === null || data === void 0 ? void 0 : data.verified) === true;
                }
                catch (_a) {
                    return false;
                }
            }));
            return results.every(Boolean);
        }
        catch (_a) {
            return false;
        }
    }
};
